import React from 'react';
import { useOfferContext } from '../../../../context';
import { GalleryLabels } from '../../../../components/GalleryLabels';

export function OfferLabelsContainer() {
  const { hasVideo, hasTour, mediaLabels } = useOfferContext();

  if (!mediaLabels.length) {
    return null;
  }

  return <GalleryLabels hasFeatures={hasVideo || hasTour} labels={mediaLabels} />;
}
